/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsroomguestsrate3Inputs */

const en_statsroomguestsrate3 = /** @type {(inputs: Statsroomguestsrate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rate`)
};

const de_statsroomguestsrate3 = /** @type {(inputs: Statsroomguestsrate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quote`)
};

/**
* | output |
* | --- |
* | "Rate" |
*
* @param {Statsroomguestsrate3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsroomguestsrate3 = /** @type {((inputs?: Statsroomguestsrate3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsroomguestsrate3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsroomguestsrate3(inputs)
	return de_statsroomguestsrate3(inputs)
});
export { statsroomguestsrate3 as "statsRoomGuestsRate" }